import { getPlaybackEnv } from '../env/playbackEnvRef'
import type { PlaylistEntry } from './PlaylistController'

/**
 * Whether an entry carries an explicit-language flag. Track-only — every
 * other entity kind (podcast, ad, audiobook) is never explicit-masked, so
 * gate on the typename first. Shared by the transport badge and the cloud
 * queue's explicit-filter omission so the "what counts as explicit" rule
 * lives in one place.
 */
export function isExplicitEntry(entry: PlaylistEntry | null): boolean {
    if (entry?.entity.__typename !== 'Track') return false
    return entry.entity.parentalSettings?.hasExplicitLanguage === true
}

/**
 * Whether the explicit-language filter is active AND this entry is explicit.
 * Read live so a mid-session toggle takes effect on the next walk.
 */
export function isFilteredByExplicit(entry: PlaylistEntry | null): boolean {
    return getPlaybackEnv().session.explicitFilter$.value && isExplicitEntry(entry)
}
